<template>
  <v-row>
    <v-dialog
      v-model="value"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      @keydown.esc="closeDialog()"
    >
      <v-card tile>
        <v-app-bar card dark color="primary">
          <v-btn icon dark @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{$t('companies.new_company')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="saveCompany()">{{$t('buttons.save')}}</v-btn>
          </v-toolbar-items>
        </v-app-bar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <h2>{{$t('overview')}}</h2>
              </v-col>
            </v-row>
            <CompanyFormOverview v-model="newCompany.overview" />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CompanyFormOverview from '@/components/companies/CompanyFormOverview.vue'

export default {
  name: 'CompanyNewDialog',
  components: {
    CompanyFormOverview
  },
  props: ['value'],
  data () {
    return {
      newCompany: {
        overview: {
          name: '',
          ico: '',
          dic: '',
          something: ''
        }
      }
    }
  },
  methods: {

    closeDialog () {
      this.$emit('input', false)
    },
    saveCompany () {
      console.log(this.newCompany)
      // TODO: save to DB
      //       fetch new data
      //       fill the company field with new created company
    }
  }

}
</script>
